export default "__VITE_ASSET__x5ouiUlI__"